export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.amantioman.com",
    backendUrl: "http://localhost:3100",
    agentBackendUrl: "http://localhost:4041",
    jsReportUrl: "http://localhost:5488",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.amantioman.com";
    exportResult.backendUrl = "https://sg-api.amantioman.com/admin";
    exportResult.agentBackendUrl =
      "https://sg-api.amantioman.com/business";
    exportResult.userPortalBackendUrl =
      "https://sg-api.amantioman.com/app";
    exportResult.jsReportUrl = "https://sg-report.amantioman.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.agentBackendUrl = "https://business-api.travoxis.com";
    exportResult.userPortalBackendUrl = "https://app-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.summerbayresort.com.my";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.amantioman.com";
    exportResult.backendUrl = "https://api.amantioman.com/admin";
    exportResult.agentBackendUrl =
      "https://api.amantioman.com/business";
    exportResult.userPortalBackendUrl =
      "https://api.amantioman.com/app";
    exportResult.jsReportUrl = "https://report.amantioman.com";
  }
  return exportResult;
};
